import React, { useEffect } from 'react';
import { translate } from '../../Services/translation';
import { query as queryAddresses } from '../../Actions/Address.action';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import AddressListItemDesktop from './ui/AddressListItemDesktop';
import AddressListItemMobile from './ui/AddressListItemMobile';
import SkeletonListItemDesktop from './ui/SkeletonListItemDesktop';
import SkeletonListItemMobile from './ui/SkeletonListItemMobile';

const MyPagesUsers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addresses } = useTypedSelector<any>((state) => state.myPage);
  const addressList = addresses.list;

  useEffect(() => {
    dispatch(queryAddresses());
  }, []);
  return (
    <div className="col-span-3">
      <h1 className="mb-2">{translate('mypage.address.title')}</h1>
      <p className="mb-4 max-w-3xl text-lg lg:mb-6">
        {translate('mypage.addresses.text') !== 'mypage.addresses.text' &&
          translate('mypage.addresses.text')}
      </p>
      <ul className="mb-2 md:mb-4 lg:hidden">
        <SkeletonListItemMobile
          items={3}
          cells={2}
          loading={!addressList}
        />
        {addressList &&
          addressList.map((address) => (
            <AddressListItemMobile
              address={address}
              key={address.systemId}
            />
          ))}
      </ul>
      <ul
        className="mb-10 hidden rounded border border-solid border-gray-300 bg-white lg:block
        [&_div:not(:last-child)]:border-b
        [&_div:not(:last-child)]:border-solid
        [&_div:not(:last-child)]:border-gray-300 [&_div:nth-child(even)]:bg-gray-100"
      >
        <div className="grid grid-cols-6 gap-4 border-b border-solid border-gray-300 p-2">
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-bold">
            {translate('mypage.address.name')}
          </p>
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-bold">
            {translate('mypage.address.address')}
          </p>
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-bold">
            {translate('mypage.address.zipcode')}
          </p>
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-bold">
            {translate('mypage.address.city')}
          </p>
          <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-bold">
            {translate('mypage.address.adresstype')}
          </p>
        </div>
        <SkeletonListItemDesktop
          items={5}
          cells={6}
          loading={!addressList}
        />
        {addressList &&
          addressList.map((address) => (
            <AddressListItemDesktop
              address={address}
              key={address.systemId}
            />
          ))}
      </ul>
      <button
        className="btn btn--primary btn--large"
        onClick={() => navigate('add')}
      >
        {translate('mypage.address.addaddress')}
      </button>
    </div>
  );
};
export default MyPagesUsers;
